<template>
    <div>
        <h2 class="title">CoP Report</h2>

       
        <div class="notification is-warning" v-if="loading == true">
            Loading members ...
        </div>
        <div class="notification is-danger" v-if="loading == false && members.length == 0">
            No active members can be found that require COP
        </div>

        <table class="table is-fullwidth is-hoverable" v-if="loading == false && this.members.length > 0">
            <thead>
                <tr>
                    <th width="50"></th>
                    <th>Forename</th>
                    <th>Surname</th>
                    <th>Date of Birth</th>
                    <th>CoP Number</th>
                    <th>Certificate Expiry</th>
                    <th>Insurance Expiry</th>
                    
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in this.members" :key="row.id" :class="{'has-background-danger-dark' : row.blocked==1, 'has-text-white' : row.blocked==1}">
                    <td><router-link :to="'/members/' + row.id + '?tab=cop'" target="_blank"><button class="button is-small is-link" >View</button></router-link></td>
                    <td>{{ row.forename }}</td>
                    <td>{{ row.surname}}</td>
                    <td>{{ row.date_of_birth_formatted}}</td>
                    <td>{{ row.cop_registration_number }}</td>
                    <td>
                        <span class="tag is-warning" v-if="row.cop_certificate_expiry == '' || row.cop_certificate_expiry == null">Not Set</span>
                        <span class="tag is-danger" v-else-if="checkDate(row.cop_certificate_expiry)">{{ row.cop_certificate_expiry }}</span>
                        <span class="tag is-success" v-else>{{ row.cop_certificate_expiry }}</span>
                        </td>
                    <td>
                        <span class="tag is-warning" v-if="row.cop_insurance_expiry == '' || row.cop_insurance_expiry == null">Not Set</span>
                        <span class="tag is-danger" v-else-if="checkDate(row.cop_insurance_expiry)">{{ row.cop_insurance_expiry }}</span>
                        <span class="tag is-success" v-else>{{ row.cop_insurance_expiry }}</span>
                    </td>
                    
                </tr>
                
                
            </tbody>
            
        </table>

       
    </div>
</template>

<script>
//import MemberService from '@/services/MemberService.js';
import MemberMixin from '@/mixins/MemberMixin.js';

//import MemberGradeTags from '@/components/Generic/MemberGradeTags.vue';

export default {
    
      name: 'MembersDashboard',
        mixins: [MemberMixin],
        components: {
            //MemberGradeTags
        },
        data: function () {
            return {
                   search: '',
                   members: [],
                   loading: false,
                  
                   showModal: false,
                   order_by: "cop_certificate_expiry ASC"
            }
        },
        methods: {
            checkDate(checkDate) {
                if(checkDate != '' && checkDate != null)
                {
                    const sqlDateParts = checkDate.split('-');
                    
                    const sqlTimestamp = new Date(sqlDateParts[0], sqlDateParts[1] - 1, sqlDateParts[2]);
                    const targetTimestamp = new Date();

                    let isBeforeTargetDate = sqlTimestamp < targetTimestamp;

                    return isBeforeTargetDate
                }
                else {
                    return false
                }
                
            },
        },
        created() {
            this.getAccessToken()
            .then(() => { 
                this.getCopMembers(this.order_by)
            });
        
        },
    }
</script>